var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 3.75C1.04175 3.40482 1.32157 3.125 1.66675 3.125H18.3334C18.6786 3.125 18.9584 3.40482 18.9584 3.75V16.25C18.9584 16.5952 18.6786 16.875 18.3334 16.875H1.66675C1.32157 16.875 1.04175 16.5952 1.04175 16.25V3.75ZM2.29175 4.375V15.625H17.7084V4.375H2.29175Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16678 3.37504C1.37389 3.09889 1.76564 3.04293 2.04178 3.25004L10.0001 9.21879L17.9585 3.25004C18.2346 3.04293 18.6263 3.09889 18.8335 3.37504C19.0406 3.65118 18.9846 4.04293 18.7085 4.25004L10.3751 10.5C10.1529 10.6667 9.84734 10.6667 9.62512 10.5L1.29178 4.25004C1.01564 4.04293 0.959678 3.65118 1.16678 3.37504Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04175 3.75C1.04175 3.40482 1.32157 3.125 1.66675 3.125H10.0001C10.3453 3.125 10.6251 3.40482 10.6251 3.75C10.6251 4.09518 10.3453 4.375 10.0001 4.375H2.29175V10C2.29175 10.3452 2.01193 10.625 1.66675 10.625C1.32157 10.625 1.04175 10.3452 1.04175 10V3.75Z",
    fill: "#BABABA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 3.75C9.375 3.40482 9.65482 3.125 10 3.125H18.3333C18.6785 3.125 18.9583 3.40482 18.9583 3.75V10C18.9583 10.3452 18.6785 10.625 18.3333 10.625C17.9882 10.625 17.7083 10.3452 17.7083 10V4.375H10C9.65482 4.375 9.375 4.09518 9.375 3.75Z",
    fill: "#BABABA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4c245c54d5b3629494bf405fffe362a0.svg";
export { ForwardRef as ReactComponent };